module.exports = __webpack_public_path__ + "img/card-3.a8ce6433.jpg";